import { useMemo } from "react";
import { Star } from "lucide-react";

import { Pill } from "components/ui/Pill";

const formatAddress = (address) => {
  if (!address) return "-";
  const parts = [
    address.addressLine1,
    address.addressLine2,
    address.addressLine3,
    address.city,
    address.county,
    address.postCode,
    address.country,
  ].filter(Boolean);
  return parts.length ? parts.join(", ") : "-";
};

export const useColumns = () => {
  return useMemo(
    () => [
      {
        id: "name",
        header: "Name",
        width: "minmax(min-content, 1fr)",
        render: (row) => (
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {row.name}
            {row.isDefault && (
              <Pill color="#0f7b3f" bg="#e6f7ee" border="#0f7b3f">
                <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <Star size={12} fill="#0f7b3f" />
                  Default
                </span>
              </Pill>
            )}
          </span>
        ),
      },
      {
        id: "address",
        header: "Address",
        width: "minmax(min-content, 2fr)",
        render: (row) => formatAddress(row.address),
      },
      {
        id: "disabled",
        header: "Status",
        width: "110px",
        render: (row) => (
          <Pill
            color={row.disabled ? "#a8371a" : "#0f7b3f"}
            bg={row.disabled ? "#fdeee9" : "#e6f7ee"}
            border={row.disabled ? "#a8371a" : "#0f7b3f"}
          >
            {row.disabled ? "Disabled" : "Active"}
          </Pill>
        ),
      },
    ],
    []
  );
};
